import { Component, Input, Output, EventEmitter } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CardModule } from 'primeng/card'

/** Intervention programmée correspondant à la recherche. */
export interface ScheduledSearchResult {
  id: number | null
  title: string
  /** Date ISO de début (tri chronologique). */
  date: string
  /** "mar. 8 juil. à 14:00". */
  dateLabel: string
  technicianName: string | null
  /** "CP Ville" du chantier. */
  location: string
  latitude: number | null
  longitude: number | null
}

/**
 * Panneau « Résultats de recherche » : remplace le panneau « Sans créneau »
 * quand une recherche sur les interventions programmées est active. Liste les
 * interventions correspondantes, triées par date croissante.
 */
@Component({
  selector: 'app-pool-scheduled-search',
  standalone: true,
  imports: [CommonModule, CardModule],
  templateUrl: './pool-scheduled-search.component.html',
  styleUrl: './pool-scheduled-search.component.scss',
})
export class PoolScheduledSearchComponent {
  @Input() query = ''
  @Input() results: ScheduledSearchResult[] = []
  /** Nombre total de correspondances (avant troncature à maxResults). */
  @Input() totalCount = 0
  @Input() selectedInterventionId: number | null = null
  @Input() loading = false

  @Output() resultSelected = new EventEmitter<ScheduledSearchResult>()
  @Output() closed = new EventEmitter<void>()
}
